import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { DeviceInfo } from '../types/device';
import { DeviceService } from '../http/device-service';

export default class DeviceStore {
    _nodeId: number;
    _loading = false;
    _items: DeviceInfo[] = [];

    constructor(nodeId: number = 0) {
        this._nodeId = nodeId;
        makeObservable<DeviceStore, '_loading' | '_items'>(this, {
            _loading: observable,
            _items: observable,
            loading: computed,
            items: computed,
            load: action,
        });
    }

    get loading(): boolean {
        return this._loading;
    }

    get items(): DeviceInfo[] {
        return this._items;
    }

    async load(): Promise<void> {
        runInAction(() => {
            this._loading = true;
        });
        try {
            const answer = await DeviceService.allByNode(this._nodeId);
            runInAction(() => {
                this._items = answer.data;
            });
        } catch (e) {
            throw e;
        } finally {
            runInAction(() => {
                this._loading = false;
            });
        }
    }
}
